import React, { useState,useRef, useEffect, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import Table from "../Table";
import { useSelector, useDispatch } from "react-redux";

import GoogleMap from 'google-map-react';

import Marker from './Marker'

const AnyReactComponent = ({ text }) => <div>{text}</div>;

///const ref = useRef(null)



const Map = ({mapPoints , fitsOn}) => {
    const [zoom , setZoomLevel] = useState(13)

  const defaultProps = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627
    },
    zoom: 11 ,
  };



function _onMapLoaded({map, maps}) {
  const bounds = new window.google.maps.LatLngBounds();
  console.log("BBBBBBBBBBBBBBBBBBBBBBBBBBB",map.zoom)
  fitsOn && fitsOn.forEach(p=>{
  bounds.extend(new window.google.maps.LatLng(p.latt, p.long));  
  })

  //
  map.setOptions({ styles: [
    {
        "featureType": "water",
        "stylers": [
            {
                "saturation": 43
            },
            {
                "lightness": -11
            },
            {
                "hue": "#0088ff"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "hue": "#ff0000"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 99
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#808080"
            },
            {
                "lightness": 54
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ece2d9"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ccdca1"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#767676"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#b8cb93"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.sports_complex",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    }
]

 });

  map.fitBounds(bounds);

  maps.event.addListener(map, 'zoom_changed', function() {
    let  zoomLevel = map.getZoom();
    console.log(zoomLevel,"change zoom")
    setZoomLevel(zoomLevel)

  })

     console.log("BBBBBBBBBBBBBBBBBBBBBBBBBBB",map.zoom)
   if(map.zoom > 13)
        map.setZoom(13)


    setZoomLevel(map.zoom)
  
}


  return (
    // Important! Always set the container height explicitly
    <div style={{ height: '90%', width: '100%' ,marginTop:'10px'}}>
      <GoogleMap  
      //ref ={ref}
        bootstrapURLKeys={{ key: "AIzaSyDTAQncqo66smjuTxSxtM4hO5z_rKDvf3U" }}
       defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
             onGoogleApiLoaded={_onMapLoaded}


 

    >

       {  mapPoints.map(p=>{
          return  <Marker lat={p.latt} lng={p.long} no={p.no} thic = {p.thic} postalCode={p.postalCode} zoom={zoom} />
  })}

      

      </GoogleMap>
    </div>
  );


};

export default Map;
